module.exports = __webpack_public_path__ + "media/entities/2030-2100d2bd.png";